"use strict";
var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import { jsx, jsxs } from "react/jsx-runtime";
import React from "react";
import ResetPasswordLayout from "../../accounts_payable/reset_password/reset_password_layout";
import FormInput from "../../util/form_input";
import DisablingButton from "../../components/disabling_button";
import Auth from "../../util/auth";
import "../../components/flash_messages";
function newPasswordComplete() {
  window.location.replace("/app/login");
}
function renderResetPasswordError(state) {
  let errors;
  if (errors = state.resetPasswordError) {
    const errorPairs = [];
    for (const key in errors) {
      errorPairs.push(
        /* @__PURE__ */ jsxs("div", { className: "alert-box alert radius", children: [
          key,
          " ",
          errors[key]
        ] })
      );
    }
    if (errorPairs.length > 0) {
      return /* @__PURE__ */ jsx("div", { className: "small-12 column", children: errorPairs });
    } else {
      return /* @__PURE__ */ jsx("div", { className: "small-12 column", children: /* @__PURE__ */ jsx("div", { className: "alert-box alert radius", children: '"An unexpected error occurred, please try again."' }) });
    }
  }
}
class ResetPasswordPage extends React.Component {
  constructor() {
    super(...arguments);
    //LIFECYCLE
    __publicField(this, "state", {
      sending: false,
      newPassword: null,
      passwordConfirmation: null,
      resetToken: window.location.search.slice(1).split("=")[1],
      resetPasswordError: null
    });
    //STATE
    __publicField(this, "getNewPassword", (e) => {
      e.preventDefault();
      this.setState({ sending: true, resetPasswordError: null });
      Auth.resetPassword({
        reset_password_token: this.state.resetToken,
        password: this.state.newPassword,
        password_confirmation: this.state.passwordConfirmation
      }).then((user) => {
        newPasswordComplete();
      }).catch((error) => {
        const response = error.response;
        response.json().then((json) => {
          this.setState({ sending: false, resetPasswordError: json.errors });
        });
      });
    });
    __publicField(this, "newPasswordChanged", (e) => {
      this.setState({ newPassword: e.target.value });
    });
    __publicField(this, "passwordConfirmationChanged", (e) => {
      this.setState({ passwordConfirmation: e.target.value });
    });
    __publicField(this, "passwordResetForm", () => {
      var _a, _b;
      return /* @__PURE__ */ jsxs("div", { className: "small-6 small-centered column general-container-style", children: [
        /* @__PURE__ */ jsx("h3", { children: "Please Enter New Password" }),
        /* @__PURE__ */ jsx("form", { onSubmit: this.getNewPassword, name: "resetPasswordForm", children: /* @__PURE__ */ jsxs("div", { className: "row", children: [
          renderResetPasswordError(this.state),
          /* @__PURE__ */ jsx(
            FormInput,
            {
              placeholder: "Password",
              onChange: this.newPasswordChanged,
              value: (_a = this.state.newPassword) != null ? _a : void 0,
              id: "password field",
              divClasses: "small-12 column",
              label: "New Password (8 characters minimum)",
              type: "password"
            }
          ),
          /* @__PURE__ */ jsx(
            FormInput,
            {
              placeholder: "Password",
              onChange: this.passwordConfirmationChanged,
              value: (_b = this.state.passwordConfirmation) != null ? _b : void 0,
              id: "password field",
              divClasses: "small-12 column",
              label: "New Password Confirmation",
              type: "password"
            }
          ),
          /* @__PURE__ */ jsx("div", { className: "small-12 column", children: /* @__PURE__ */ jsx(
            DisablingButton,
            {
              disabledText: "Resetting Password...",
              disabled: this.state.sending,
              className: "button--confirmation",
              children: "Set New Password"
            }
          ) })
        ] }) })
      ] });
    });
  }
  render() {
    return /* @__PURE__ */ jsx(ResetPasswordLayout, { "data-component": "ResetPasswordPage", children: this.passwordResetForm() });
  }
}
export default ResetPasswordPage;
